import { Component, Input, Output,EventEmitter, ViewChild } from '@angular/core';

/**
 * Generated class for the GmoPaymentComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: 'paygent-payment',
  templateUrl: 'paygent-payment.html'
})
export class PaygentPaymentComponent {

    
    @ViewChild('paygentForm') paygentForm: any;
    paygentpayment:any;

    constructor() {
    }

    submit(){
        this.paygentForm.nativeElement.submit();
    }

}



// WEBPACK FOOTER //
// ./src/components/paygent-payment/paygent-payment.ts